import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

type Props = {
  isOpen: boolean;
  state: string;
  onClose?: () => void;
};

const ResultModal = ({ isOpen, state, onClose }: Props) => {
  const { t } = useTranslation('translation');
  const navigate = useNavigate();

  const getContent = (currentState: string) => {
    switch (currentState) {
      case 'SUBMITTED':
        return {
          title: t('orders.ORDER_SUBMISSION_SUCCESS_HEADING'),
          description: t('orders.ORDER_SUBMISSION_SUCCESS_CONTENT'),
        };
      case 'ERROR':
        return {
          title: t('orders.ORDER_SUBMISSION_ERROR_HEADING'),
          description: t('orders.ORDER_SUBMISSION_ERROR_CONTENT'),
        };
      default:
        return { title: '', description: t('orders.ORDER_SUBMISSION_PENDING') };
    }
  };

  return (
    <Modal isOpen={isOpen} onClosed={() => onClose && onClose()}>
      <ModalHeader>{getContent(state).title}</ModalHeader>
      <ModalBody>{getContent(state).description}</ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            onClose && onClose();
            state === 'SUBMITTED' && navigate('/service/order');
          }}
        >
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ResultModal;
